/* eslint no-param-reassign: 0 */
import SkiSchoolCartItem from '@/classes/SkiSchoolCartItem';
import { refreshCart } from '@/store-methods/mutations/accomodation';

export const addSkiSchoolToCart = ($, payload) => {
  const item = new SkiSchoolCartItem();

  item.pool_lid = payload.pool_lid;
  item.people = payload.people;

  item.confirmed = true;

  item.date = payload.date;
  item.days = payload.days;
  item.site = payload.site;
  item.activity_lid = payload.activity_lid;
  item.time = payload.time;

  item.name = payload.name;

  item.guardian = payload.guardian;
  item.phone = payload.phone;

  item.price = Math.round(parseFloat(payload.price));

  item.quantity = payload.quantity;

  $.cart.skischools.push(item);

  refreshCart($);

  $.skiSchoolBooking = {};
};

export const consolidateSkiSchoolInCart = ($, payload) => {
  /* eslint-disable */
  let indexToUpdate = '';
  const indexesToRemove = [];

  console.log(payload);

  for (var i in $.cart.skischools) {
    if (payload.activity_lid === $.cart.skischools[i].activity_lid) {
      indexesToRemove.push(i);
    }
  }

  if (indexesToRemove.length) {
    // Take the first from indexesToRemove, remove it from the list and add it to indexesToUpdate
    const first = indexesToRemove.shift();
    indexToUpdate = first;

    let tempSchools = JSON.parse(JSON.stringify($.cart.skischools));

    for (var i in indexesToRemove) {
      const index = indexesToRemove[i];
      for (var ii in tempSchools[index].people) {
        tempSchools[indexToUpdate].people.push(tempSchools[index].people[ii]);
      }
    }

    // Remove all schools from indexesToRemove
    for (var i in indexesToRemove) {
      const index = indexesToRemove[i];
      tempSchools.splice(index, 1);
    }

    tempSchools[indexToUpdate].price = payload.price;
    tempSchools[indexToUpdate].quantity = tempSchools[indexToUpdate].people.length;

    console.log(tempSchools);

    $.cart.skischools = tempSchools;
  }
  /* eslint-enable */
};

export const addActivitityToCart = ($, payload) => {
  const item = new SkiSchoolCartItem();

  item.pool_lid = payload.pool_lid;
  item.people = payload.people;

  item.confirmed = true;

  item.date = payload.date;
  item.days = payload.days;
  item.site = payload.site;
  item.activity_lid = payload.activity_lid;
  item.time = payload.time;

  item.name = payload.name;

  item.guardian = payload.guardian;
  item.phone = payload.phone;

  item.price = Math.round(parseFloat(payload.price));

  item.quantity = payload.quantity;

  if (!$.cart.activities) {
    $.cart.activities = [];
  }

  $.cart.activities.push(item);

  refreshCart($);

  $.skiSchoolBooking = {};
};

export const setSkischoolFilter = ($, filter) => {
  $.skiSchoolFilter = Object.assign({}, filter);
};

export const setSkischoolFilterAttribute = ($, filter) => {
  $.skiSchoolFilter[filter.property] = filter.value;
};

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/skischool.js